/* ── ElShowTCG Search ──────────────────────────────────────── */
(function () {
  'use strict';

  const input = document.getElementById('search-input');
  const suggestions = document.getElementById('search-suggestions');
  if (!input || !suggestions) return;

  let debounceTimer;

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const q = this.value.trim();

    if (q.length < 2) {
      suggestions.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(async () => {
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const data = await res.json();
        const products = data.resources?.results?.products || [];

        if (products.length === 0) {
          suggestions.innerHTML = '';
          return;
        }

        // Los títulos vienen de la API; se escapan antes de inyectarlos.
        const esc = s => String(s).replace(/[&<>"']/g, ch =>
          ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

        suggestions.innerHTML = products.map(p => `
          <a href="${esc(p.url)}" class="suggestion-item" role="option">
            <span>${esc(p.title)}</span>
          </a>
        `).join('');
      } catch (e) {
        suggestions.innerHTML = '';
      }
    }, 280);
  });

  document.addEventListener('click', e => {
    if (!input.contains(e.target) && !suggestions.contains(e.target)) {
      suggestions.innerHTML = '';
    }
  });

  input.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      suggestions.innerHTML = '';
      document.getElementById('header-search')?.classList.remove('active');
    }
  });
})();
